import { baseApi } from "@/redux/api/baseApi";
import { TResponseRedux, TUser } from "@/types/types";
import { TCreatorBalance, TTransaction } from "./creatorBalanceTypes";

export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};

const creatorBalanceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBalance: builder.query({
      query: (args) => {
        return {
          url: `/creator-balance/get-balance`,
          method: "GET",
          params:args
        };
      },
      providesTags: ["CreatorBalance"],
      transformResponse: (res: TResponseRedux<TCreatorBalance>, meta) => {
        return {
          data: res.data,
          error: res.error,
        };
      },
    }),
    getTransactions: builder.query({
      query: (args) => {
        return {
          url: `/creator-balance/get-transactions`,
          method: "GET",
          params: args
        };
      },
      providesTags: ["CreatorTransactions"],
     
    }),

  }),
});

export const {
 useGetBalanceQuery,
 useGetTransactionsQuery
} = creatorBalanceApi;
